//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import UMUM from  '../../../library/umum'
import uniqid from 'uniqid';

export default {
  data() {
    return {

        form : {
            id : '',
            judul : '',
            thn : '',
            penulis : '',
            penerbit : '',
            blok : '',
            bilik : '',
            uraian : '',
            des_kel : this.$store.state.ID_DES_KEL,
            createdAt : '',
            createdBy : '',
            file : null,
        },

        fileOld : '',




        list_data : [],
        page_limit : 8,
        page_first: 1,
        page_last: 0,
        cari_value: "",
        cek_load_data : true,


        mdl_add: false,
        mdl_edit: false,
        mdl_hapus : false,
        mdl_lihat: false,
        mdl_lihat_file: false,
        btn_add: false,

        UMUM : UMUM,
    }
  },
  methods: {


    getView : function(){
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.URL_ADM_DESA_DOK_PERPUSTAKAAN_DIGITAL + "view", {
          method: "POST",
          headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({
              des_kel : this.form.des_kel,
              data_ke: this.page_first,
              page_limit : this.page_limit,
              cari_value: this.cari_value
          })
      })
          .then(res => res.json())
          .then(res_data => {
              this.list_data = res_data.data;
              this.page_last = res_data.jmlData;
              this.$store.commit("hideLoading");
              // console.log(res_data);
      });
    },


    addData : function(number) {


        var formData = new FormData();

        formData.append("id", uniqid());
        formData.append("judul", this.form.judul);
        formData.append("thn", this.form.thn);
        formData.append("penulis", this.form.penulis);
        formData.append("penerbit", this.form.penerbit);
        formData.append("blok", this.form.blok);
        formData.append("bilik", this.form.bilik);
        formData.append("uraian", document.getElementById("editor").value);
        formData.append("des_kel", this.form.des_kel);
        formData.append("createdAt", UMUM.NOW());
        formData.append("file", this.form.file);


        fetch(this.$store.state.url.URL_ADM_DESA_DOK_PERPUSTAKAAN_DIGITAL + "addData", {
            method: "POST",
            headers: {
                // "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
            },
            body: formData
        }).then(res_data => {
            this.Notify('Sukses Menambah Data', 'primary', 'check_circle_outline');
            this.getView();
        });

        // console.log(document.getElementById("editor").value)
    },


    editData : function(){

      var formData = new FormData();

        formData.append("id", this.form.id);
        formData.append("judul", this.form.judul);
        formData.append("thn", this.form.thn);
        formData.append("penulis", this.form.penulis);
        formData.append("penerbit", this.form.penerbit);
        formData.append("blok", this.form.blok);
        formData.append("bilik", this.form.bilik);
        formData.append("uraian", document.getElementById("editor").value);
        formData.append("createdAt", this.form.createdAt);
        formData.append("file", this.form.file);

        formData.append("fileOld", this.fileOld);



 
      this.form.keterangan = document.getElementById("editor").value;
      fetch(this.$store.state.url.URL_ADM_DESA_DOK_PERPUSTAKAAN_DIGITAL + "editData", {
          method: "POST",
          headers: {
            // "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: formData
      }).then(res_data => {
          this.Notify('Sukses Merubah Data', 'warning', 'check_circle_outline');
          this.getView();
      });
    },

    removeData : function(E){
      fetch(this.$store.state.url.URL_ADM_DESA_DOK_PERPUSTAKAAN_DIGITAL + "removeData", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({
              id : this.form.id,
              fileOld : this.fileOld,

          })
      }).then(res_data => {
          this.Notify('Sukses Menghapus Data', 'negative', 'check_circle_outline');
          this.getView();
      });

    },
    selectData : function(data){
      console.log(data)
      this.form.id = data.id;
      this.form.judul= data.judul;
      this.form.thn= data.thn;
      this.form.penulis= data.penulis;
      this.form.penerbit= data.penerbit;
      this.form.blok= data.blok;
      this.form.bilik= data.bilik;
      this.form.uraian = data.uraian;
      this.form.createdAt = data.createdAt;
      this.form.createdBy = data.createdBy;
      // this.form.file = data.file;

      this.fileOld = data.file;

      console.log(data.file)
  




    },

    emptytData : function(data){

            this.form.id = '';
            this.form.judul = '';
            this.form.thn = '';
            this.form.penulis = '';
            this.form.penerbit = '';
            this.form.blok = '';
            this.form.bilik = '';
            this.form.uraian = '';
            this.form.createdAt = '';
            this.form.createdBy ='';
            this.form.file = null;


        this.fileOld ='';

    },


    // ====================================== PAGINATE ====================================
        Notify : function(message, positive, icon){
          this.$q.notify({
            message: message,
            color: positive,
            icon: icon,
            position : 'top',
            timeout: 500,
          })
        },

        cari_data : function(){
            this.page_first = 1;
            this.getView();
        },

        indexing : function(index){
            var idx = ((this.page_first-1)*this.page_limit)+index
            return idx
        },

        convert_tgl: function(dateString) {
                    var date = new Date(dateString);
                    var getBulan = date.getMonth() + 1; var bulan = '';
                    if (getBulan == '1') {bulan = 'Jan'} 
                    else if(getBulan == '2') {bulan = 'Feb'}
                    else if(getBulan == '3') {bulan = 'Mar'}
                    else if(getBulan == '4') {bulan = 'Apr'}
                    else if(getBulan == '5') {bulan = 'Mei'}
                    else if(getBulan == '6') {bulan = 'Jun'}
                    else if(getBulan == '7') {bulan = 'Jul'}
                    else if(getBulan == '8') {bulan = 'Agt'}
                    else if(getBulan == '9') {bulan = 'Sep'}
                    else if(getBulan == '10') {bulan = 'Okt'}
                    else if(getBulan == '11') {bulan = 'Nov'}
                    else if(getBulan == '12') {bulan = 'Des'}

                    return date.getDate() + " " + bulan + " " + date.getFullYear();
                    // return bulan+ " " + date.getDate() + ". " + date.getFullYear();
                },




    // ====================================== PAGINATE ====================================







  },

  mounted () {
        // new FroalaEditor('textarea#froala-editor')
        var profilex = JSON.parse(localStorage.profile)
        var profile = profilex.profile
        this.$store.state.ID_DES_KEL = profile.des_kel
        this.form.des_kel = profile.des_kel

        this.getView();
  },
}
